import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Colors, FindLoad, FindSuccess, useGlobalTextStyles, useModal, useSecondaryModal } from 'utils';
import { modalsStyle } from './styles';
import { MinLoader } from '../loader';
import { httpRequestsOnSuccessActions } from 'store';

export const CustomDelete = ({
    text,
    info,
    handleDel,
    actionType,
    innerText = '',
    body,
    align,
    afterSuccess,
    color,
    handleClose,
    noClose,
    customConfirmBtn,
    loaderColor,
    disableAction,
    innerIcon,
    okBtn,
    header,
    closeSecondaryModal,
}) => {
    const classes = modalsStyle();
    const globalText = useGlobalTextStyles();
    const loader = FindLoad(actionType);
    const success = FindSuccess(actionType);
    const dispatch = useDispatch();
    const { close } = useModal();
    const { closeSecondary } = useSecondaryModal();

    useEffect(() => {
        if (success?.length && !noClose) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(actionType));
            if (closeSecondaryModal) {
                closeSecondary();
            } else {
                close();
            }

            if (afterSuccess) {
                afterSuccess();
            }
        }
    }, [success]);

    const handleCloseModal = () => {
        if (handleClose) {
            handleClose();
        } else {
            if (closeSecondaryModal) {
                closeSecondary();
            }else{
                close();
            }
        }
    };
    return (
        <div className={classes.customDeleteModal}>
            <div style={align ? { textAlign: align } : {}}>
                {header && header}
                <p className={globalText.modalTitle}>{info}</p>
                <p className={globalText.modalText}>{text}</p>
                {body && body}

                {okBtn ? (
                    <div className={classes.buttons}>
                        <button
                            className="ok-btn-box"
                            onClick={() => {
                                close();
                                if (handleDel) {
                                    handleDel();
                                }
                            }}>
                            OK
                        </button>
                    </div>
                ) : (
                    <div className={classes.buttons}>
                        <button className="close-btn-box" onClick={handleCloseModal}>
                            Cancel
                        </button>
                        <button
                            style={{ opacity: disableAction ? 0.5 : 1 }}
                            disabled={disableAction || loader?.length}
                            className={customConfirmBtn ? customConfirmBtn : color === 'blue' ? 'confirm-btn' : 'delete-btn-box'}
                            onClick={handleDel}>
                            {loader?.length ? (
                                <MinLoader margin={'0'} color={loaderColor ? loaderColor : Colors.TextWhite} />
                            ) : (
                                <>
                                    {innerIcon && <img src={innerIcon} alt="icon" />}
                                    {innerText || 'Delete'}
                                </>
                            )}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
